import * as React from "react";
import { WithStyles, withStyles, Theme, createStyles, CircularProgress, Typography, Fade } from "@material-ui/core";
import * as classNames from "classnames";

export interface ContentCircularProgressProps {
  loadingText?: string;
  loadingTextDelaySeconds?: number;
  className?: string;
  ignorePrimaryColor?: boolean;
}

interface ContentCircularProgressState {
  showLoadingText: boolean;
}

interface ContentCircularProgressOwnProps extends ContentCircularProgressProps, WithStyles<typeof styles> {}

class ContentCircularProgress extends React.PureComponent<
  ContentCircularProgressOwnProps,
  ContentCircularProgressState
> {
  state = {
    showLoadingText: false
  };

  handleShowLoadingText = () => {
    this.setState({
      showLoadingText: true
    });
  };

  componentDidMount() {
    if (this.props.loadingText) {
      let loadingTextDelay = 0;
      if (this.props.loadingTextDelaySeconds) {
        loadingTextDelay = this.props.loadingTextDelaySeconds * 1000;
      }

      if (loadingTextDelay > 0) {
        setTimeout(this.handleShowLoadingText.bind(this), loadingTextDelay);
      } else {
        this.handleShowLoadingText();
      }
    }
  }

  render() {
    const { classes, loadingText, className, ignorePrimaryColor } = this.props;
    const { showLoadingText } = this.state;
    return (
      <div className={className}>
        <div className={classes.root}>
          <CircularProgress
            className={classNames(classes.progress, ignorePrimaryColor ? classes.useDefaultColor : "")}
            color={"primary"}
          />
        </div>
        <Fade in={showLoadingText && loadingText !== undefined}>
          <div className={classes.loadingTextParent}>
            <Typography className={classes.loadingText}>{loadingText}</Typography>
          </div>
        </Fade>
      </div>
    );
  }
}

const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      justifyContent: "center",
      overflow: "hidden"
    },
    progress: {
      margin: theme.spacing.unit * 2 + "rem"
    },
    loadingTextParent: {
      maxWidth: "20rem",
      margin: "auto",
      textAlign: "center"
    },
    loadingText: {
      color: theme.palette.grey[500]
    },
    useDefaultColor: {
      color: "grey"
    }
  });

export default withStyles(styles)(ContentCircularProgress);
